import {
  ClientCommunicationListingModel,
  IClientCommunicationListingModel,
  IModel,
  Model,
  ModelRecord,
} from '@common/models';

export interface ISendSMSResponseModel extends IModel {
  wasSent: boolean | undefined;
  communication: IClientCommunicationListingModel | undefined;
}

export class SendSMSResponseModel
  extends Model
  implements ModelRecord<ISendSMSResponseModel>
{
  wasSent: boolean | undefined;
  communication: ClientCommunicationListingModel | undefined;

  constructor(params?: Partial<ISendSMSResponseModel>) {
    super(params);
    this.wasSent = _.defaultTo(params?.wasSent, false);
    this.communication = new ClientCommunicationListingModel(
      params?.communication,
    );
  }
}
